// resources/js/tracking/utm-attribution.js
//
// First-touch UTM attribution. Captures UTM params from the current URL
// on the very first visit (when no record exists yet) and persists them
// to localStorage for the lifetime of the device. These are merged into
// people.set on register / login so we know where each user originally
// came from, regardless of the registration trigger.

const STORAGE_KEY = 'mh.first_touch';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const PAID_CLICK_KEYS = ['fbclid', 'ttclid', 'gclid'];

export function captureFirstTouchIfMissing() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  if (window.localStorage.getItem(STORAGE_KEY)) return;

  const url = new URL(window.location.href);
  const params = url.searchParams;
  const captured = {};

  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) captured[k] = v;
  });
  PAID_CLICK_KEYS.forEach((k) => {
    if (params.get(k)) captured[k] = params.get(k);
  });

  // Always store, even if empty — first touch is "direct" if no UTMs.
  captured.captured_at = new Date().toISOString();
  captured.referrer = document.referrer || null;

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
}

export function getFirstTouch() {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

/**
 * Derives a coarse "signup_source" label from the first-touch data.
 * Used as people.signup_source.
 */
export function deriveSignupSource(firstTouch) {
  if (!firstTouch) return 'direct';

  if (firstTouch.fbclid || firstTouch.utm_source === 'facebook') return 'paid_fb';
  if (firstTouch.ttclid || firstTouch.utm_source === 'tiktok') return 'paid_tiktok';
  if (firstTouch.gclid || firstTouch.utm_source === 'google') return 'paid_google';
  if (firstTouch.utm_medium === 'affiliate') return 'affiliate';

  if (firstTouch.referrer) {
    if (/google|bing|duckduckgo|qwant|ecosia/i.test(firstTouch.referrer)) {
      return 'organic_search';
    }
    return 'referral';
  }

  return 'direct';
}
